document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".product-card").forEach(card => {

        const images = card.querySelectorAll(".product-hover-image");

        if (images.length <= 1) return;

        let index = 0;
        let timer = null;

        function showImage(i){

            images.forEach(img => img.style.opacity = 0);

            images[i].style.opacity = 1;

        }

        card.addEventListener("mouseenter", () => {

            index = 1;

            showImage(index);

            timer = setInterval(() => {

                index++;

                if(index >= images.length){

                    index = 0;

                }

                showImage(index);

            },700);

        });

        card.addEventListener("mouseleave", () => {

            clearInterval(timer);

            index = 0;

            showImage(0);

        });

    });

});